<template>
  <div class="apply">
    <div class="banner">
      <img src="../assets/applybanner.jpg" alt="">
    </div>
    <div class="container">
      <div class="title">
        <div class="en">Apply Online</div>
        <div class="cn" v-if="$i18n.locale === 'zh-CN'">在线应聘</div>
      </div>
      <div class="form">
        <el-form ref="ruleForm" :model="form" :rules="rules" label-width="100px">
<!--          <el-form-item label="岗位类型：" prop="postType">-->
<!--            <el-radio-group v-model="form.postType">-->
<!--              <el-radio :label="'生产管理'">生产管理</el-radio>-->
<!--              <el-radio :label="'技术研发'">技术研发</el-radio>-->
<!--              <el-radio :label="'市场营销'">市场营销</el-radio>-->
<!--              <el-radio :label="'财务管理'">财务管理</el-radio>-->
<!--            </el-radio-group>-->
<!--          </el-form-item>-->
          <el-form-item :label="$t('form')[0]" prop="post">
            <el-input v-model="form.post"></el-input>
          </el-form-item>
          <el-form-item :label="$t('form')[1]" prop="name">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('form')[2]" prop="sex">
            <el-radio-group v-model="form.sex">
              <el-radio :label="'男'">{{$t('form')[3]}}</el-radio>
              <el-radio :label="'女'">{{$t('form')[4]}}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('form')[5]" prop="tel">
            <el-input v-model="form.tel" type="tel"></el-input>
          </el-form-item>
          <el-form-item :label="$t('form')[6]" prop="birthday">
            <el-date-picker type="date" :placeholder="$t('form')[7]" v-model="form.birthday"></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('form')[8]">
            <el-input v-model="form.nativeplace"></el-input>
          </el-form-item>
          <el-form-item :label="$t('form')[9]" prop="marriages">
            <el-radio-group v-model="form.marriages">
              <el-radio :label="'未婚'">{{$t('form')[10]}}</el-radio>
              <el-radio :label="'已婚'">{{$t('form')[11]}}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('form')[12]">
            <el-input v-model="form.education"></el-input>
          </el-form-item>
          <el-form-item :label="$t('form')[13]">
            <el-input v-model="form.major"></el-input>
          </el-form-item>
          <el-form-item :label="$t('form')[14]">
            <el-input v-model="form.academy"></el-input>
          </el-form-item>
          <el-form-item :label="$t('form')[15]">
            <el-input type="textarea" v-model="form.skill" rows="6"></el-input>
          </el-form-item>
          <el-form-item :label="$t('form')[16]">
            <el-input v-model="form.workinglife"></el-input>
          </el-form-item>
          <el-form-item :label="$t('form')[17]">
            <el-input v-model="form.salary"></el-input>
          </el-form-item>
          <el-form-item :label="$t('form')[18]">
            <el-input v-model="form.address"></el-input>
          </el-form-item>
          <el-form-item :label="$t('form')[19]" prop="email">
            <el-input v-model="form.email" type="email"></el-input>
          </el-form-item>
          <el-form-item :label="$t('form')[20]" prop="resume">
            <el-input type="textarea" v-model="form.resume" rows="6"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit('ruleForm')">{{$t('form')[21]}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import Scrollbar from 'smooth-scrollbar';
import  qs from 'qs'
export default {
  data(){
    return{
      scrollbar: "",
      form: {
        postType: '生产管理',
        post: '',
        name: '',
        sex: '男',
        tel: '',
        birthday: '',
        nativeplace: '',
        marriages: '未婚',
        education: '',
        major: '',
        academy: '',
        skill: '',
        workinglife: '',
        salary: '',
        address: '',
        email: '',
        resume: ''
      },
      rules: {
        postType: [
          { required: true, message: '请选择岗位类型', trigger: 'blur' }
        ],
        post: [
          { required: true, message: '请输入应聘岗位', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        sex: [
          { required: true, message: '请输入性别', trigger: 'blur' }
        ],
        tel: [
          { required: true, message: '请输入联系手机', trigger: 'blur' },
          { len: 11, message: '长度在 11 位数字', trigger: 'blur' }
        ],
        birthday: [
          { required: true, message: '请输入生日', trigger: 'blur' }
        ],
        marriages: [
          { required: true, message: '请选择婚姻状况', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入电子邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确格式的电子邮箱', trigger: 'blur' }
        ],
        resume: [
          { required: true, message: '请输入工作简历', trigger: 'blur' }
        ]
      }
    }
	},
	methods: {
		onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$nextTick(()=>{
            const url ='/php/form.php'
            this.$axios.post(url,
                    qs.stringify(
                            this.form
                    )
            ).then(res => {
              if(res.status===200)
              {
                this.$notify({
                  title: 'Success',
                  message: 'Submitted Successfully',
                  offset: 100
                })
                this.form={
                  postType: '生产管理',
                  post: '',
                  name: '',
                  sex: '男',
                  tel: '',
                  birthday: '',
                  nativeplace: '',
                  marriages: '未婚',
                  education: '',
                  major: '',
                  academy: '',
                  skill: '',
                  workinglife: '',
                  salary: '',
                  address: '',
                  email: '',
                  resume: ''
                }
              }else{
                this.$notify({
                  title: '失败',
                  message: '提交失败',
                  offset: 100
                });
              }
            })
          })
        } else {
          this.$notify({
                title: 'Failure',
                message: 'Please Complete',
                offset: 100
            });
        }
      });
    }
	},
  mounted(){
    this.scrollbar = Scrollbar.init(document.getElementById('scroller-wrapper'));
    localStorage.setItem('index','5')
  }
}
</script>

<style scoped>
.apply .container{
  background-color: #f5f6f7;
}
.apply .container .title{
  text-align: center;
  padding: 40px 0;
}
.apply .container .title .en{
  font-size: 25px;
}
.apply .container .title .cn{
  font-size: 30px;
}
.apply .container .back{
  max-width: 1000px;
  margin: 0 auto;
  justify-content: flex-end;
}
.apply .container .form{
  padding: 20px 0;
}
.apply .container .form form{
  max-width: 1000px;
  margin: 0 auto;
}
.apply .container .form form .el-input{
  max-width: 300px;
}
.apply .container .form form .el-button{
  display: block;
  margin: 0 auto;
}
@media (max-width: 768px){
  .apply .container .back{
    justify-content: center;
  }
  .apply .container .form{
    padding-left: 20px;
    padding-right: 20px;
  }
}
</style>

<style>
@media (max-width: 768px){
  .apply .el-radio{
    display: block;
  }
  .apply .el-radio+.el-radio{
    margin-left: 0;
  }
  .apply .el-input{
    width: 100%;
  }
}
</style>

